export default {"src":"/_next/static/media/opensea-logo.4297df11.svg","height":50,"width":56};